import React from "react";

interface CloseIconProps {
  size?: "default" | "small" | "xs";
}

const CloseIcon: React.FC<CloseIconProps> = ({ size = "default" }) => {
  let left = "36px";
  if (size === "small") {
    left = "30px";
  } else if (size === "default") {
    left = "36px";
  } else if (size === "xs") {
    left = "22vpx";
  }
  return (
    <div
      style={{
        width: "8px",
        height: "8px",
        background: "#000",
        padding: "2px",
        borderRadius: "50%",
        position: "absolute",
        top: "-2px",
        left: left,
      }}
    >
      <svg
        style={{
          display: "block",
        }}
        width="8"
        height="8"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.0797 19.0675L4.93752 4.92539M4.9375 19.0746L19.0796 4.93247"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export default CloseIcon;
